import PageTitleWithRouteTitle from './PageTitleWithRouteTitle';

// eslint-disable-next-line import/prefer-default-export
export { PageTitleWithRouteTitle };
